<template>
    <a-modal
    :title="title"
    :width="1000"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
      <a-spin :spinning="confirmLoading">
        <a-tabs v-model="activeKey" @change="changeTab">
          <a-tab-pane :key="1" :tab="$t('数据详情')">
            <detail-list :col="2">
                <template v-if="model.isWarn==1">
                    <detail-list-item :term="$t('告警等级')">
                        <label :class="model.warnClevel === 1?'warn-danger':model.warnClevel === 2?'warn-primary':model.warnClevel === 3?'warn-secondary':''">
                        {{'maintenance_warn_clevel'|filterDictTextByCache(model.warnClevel)}}
                        </label>
                    </detail-list-item>
                    <detail-list-item :term="$t('部门名称')">{{model.departName}}</detail-list-item>
                    <detail-list-item :term="$t('表具总数')">{{model.meterTotalCount}}</detail-list-item>
                    <detail-list-item :term="$t('问题表数')">{{model.meterPoorSignalCount}}</detail-list-item>
                    <detail-list-item :term="$t('占比')">{{model.meterPoorSignalPercent+'%'}}</detail-list-item>
                    <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
                    <detail-list-item :term="$t('告警规则')">{{model.warnName}}</detail-list-item>
                    <detail-list-item :term="$t('告警时间')">{{model.createTime}}</detail-list-item>
                    <detail-list-item :term="$t('告警描述')">{{model.meterWarnDetail}}</detail-list-item>
                    <detail-list-item :term="$t('处理状态')">{{model.meterDealStatus==2?$t('已处理'):model.meterDealStatus==1?$t('处理中'): $t('未处理')}}</detail-list-item>
                    <detail-list-item :term="$t('处理描述')">{{model.meterDealStatus==2?model.meterDealDescription2:model.meterDealStatus==1?model.meterDealDescription1: model.meterDealDescription0}}</detail-list-item>
                </template>
                <template v-else>
                    <detail-list-item :term="$t('部门名称')">{{model.departName}}</detail-list-item>
                    <detail-list-item :term="$t('表具总数')">{{model.meterTotalCount}}</detail-list-item>
                    <detail-list-item :term="$t('问题表数')">{{model.meterPoorSignalCount}}</detail-list-item>
                    <detail-list-item :term="$t('占比')">{{model.meterPoorSignalPercent}}</detail-list-item>
                    <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
                    <detail-list-item :term="$t('创建时间')">{{model.createTime}}</detail-list-item>
                </template>
            </detail-list>
          </a-tab-pane>
          <a-tab-pane :key="2" :tab="$t('问题表清单')">
            <div class="form-contain">
              <div class="table-page-search-wrapper">
                <a-form layout="inline" @keyup.enter.native="searchQuery">
                  <a-row :gutter="24">
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                        <a-form-item :label="$t('表号')">
                        <a-input :placeholder="$t('输入表号进行查询')" v-model="queryParam.meterId"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :xl="8" :lg="7" :md="8" :sm="24">
                      <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                      <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                      </span>
                    </a-col>
                  </a-row>
                </a-form>
              </div>
              <div>
                <detail-list :col="3">
                  <detail-list-item :term="$t('部门编号')">{{model.sysOrgCode}}</detail-list-item>
                  <detail-list-item :term="$t('部门名称')">{{model.departName}}</detail-list-item>
                  <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
                </detail-list>
              </div>
                <a-table 
                  :columns="columns"
                  :dataSource="dataSource"
                  :scroll="{x:true}"
                  rowKey='id'
                  size="middle"
                  :pagination="ipagination"
                  @change="handleTableChange"
                  class="j-table-force-nowrap"
                >
                </a-table>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </a-modal>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import echarts from 'echarts/lib/echarts';
  import moment from 'moment'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import { isEmptyObject,isUndefined } from '@/utils/validate'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  const colorList = ['#FECA20','#50E3C2', '#0091FF','#4634FA','#B620E0','#F7B500','#FA6400','#E02020'];
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterUserAccountForm',
    mixins:[JeecgListMixin],
    filters: {
      filterDictTextByCache
    },
    components: {
      JFormContainer,
      DetailList,
      DetailListItem
    },
    data () {
      return {
        model: {},
        netTypeObj,
        meterTypeObj,
        title: '',
        confirmLoading: false,
        disableSubmit:false,
        visible: false,
        validatorRules: {
        },
        url: {
          list: "/jeecg-charge/meter/meterSignalAnalysisRecord/list"
        },
        date:[],
        dateType: 2,
        activeKey: 1,
        disableMixinCreated: true,
        uniqueParam: {},
        option: {}
      }
    },
    computed: {
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId'
          },
          {
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'meterType',
            customRender: (t,r,index) => {
              let data = meterTypeObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            },
          },
          {
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr'
          },
          {
            title:'RSRP',
            align:"center",
            dataIndex: 'signalRsrp'
          },
          {
            title:'SNR',
            align:"center",
            dataIndex: 'signalSnr'
          },
          {
            title:'CSQ',
            align:"center",
            dataIndex: 'signalCsq'
          }
        ]
      }
    },
    created () {
    },
    methods: {
      moment,
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.uniqueParam.meterSignalAnalysisKeyId = this.model.id;
        this.changeTab(1);
        this.disableSubmit = true;
        this.visible = true;
      },
      shut() {
        this.activeKey = 1;
        this.queryParam = {}
      },
      close () {
        this.$emit('close');
        this.shut();
        this.disableSubmit = false;
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.formModal.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })

          }
        })
      },
      handleCancel () {
        this.close()
      },
      changeTab() {
        console.log(this.activeKey)
        if(this.activeKey == 2) {
          this.loadData(1)
        }
      }
    }
  }
</script>
<style scoped>
.detail-list >>> .term{
  line-height: 22px;
}
.m-panel-body{
  margin-top: 20px;
  height: 500px;
}
</style>